import { TFunction } from 'i18next';
import * as Yup from 'yup';

const validationSchema = (t: TFunction) => {
  return Yup.object({
    show_jobs: Yup.boolean().default(false)
  });
};

export { validationSchema };
